import { Action } from "@ngrx/store";
import { IDiaprofilHcp } from "../../models/types";

export const RESET_STATE = "[hcp] ResetState";
export const ADD = "[hcp] Add";
export const UPDATE = "[hcp] Update";
export const DELETE = "[hcp] Delete";
export const REPLACE = "[hcp] Replace";

export interface HcpUserPayload extends Partial<IDiaprofilHcp> {
  fhirId: string;
}

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */
export class ResetStateAction implements Action {
  readonly type = RESET_STATE;
  constructor(public payload?: HcpUserPayload) {}
}

export class AddAction implements Action {
  readonly type = ADD;
  constructor(public payload: IDiaprofilHcp) {}
}

export class ReplaceAction implements Action {
  readonly type = REPLACE;
  constructor(public payload: IDiaprofilHcp) {}
}

export class UpdateAction implements Action {
  readonly type = UPDATE;
  constructor(public payload: HcpUserPayload) {}
}

export class DeleteAction implements Action {
  readonly type = DELETE;
  constructor(public payload: HcpUserPayload) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | ResetStateAction
  | AddAction
  | ReplaceAction
  | UpdateAction
  | DeleteAction;



// WEBPACK FOOTER //
// ./src/app/store/actions/hcp-user.actions.ts